import { render, staticRenderFns } from "./chateau-taillefer.vue?vue&type=template&id=389a0e1d&scoped=true"
import script from "./chateau-taillefer.vue?vue&type=script&lang=js"
export * from "./chateau-taillefer.vue?vue&type=script&lang=js"
import style0 from "./chateau-taillefer.vue?vue&type=style&index=0&id=389a0e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a0e1d",
  null
  
)

export default component.exports